import { render } from "./TemplateF.vue?vue&type=template&id=30f61db4"
import script from "./TemplateF.vue?vue&type=script&lang=js"
export * from "./TemplateF.vue?vue&type=script&lang=js"
script.render = render

export default script